module.exports = __webpack_public_path__ + "media/meme-select.b0d1c658.mp3";